import { Component, OnInit, Input } from '@angular/core';
import { HomeEstimatorService, HomeEstimatorRequest, HomeEstimatorResponse, Property } from '../../../services/home-estimator.service';
import { ObjectResponse } from '../../../classes/object-response';
import { Listing } from '../../../classes/listing';
import { UserService } from '../../../services/user.service';
import { BritishColumbiaStateShort } from '../../../app-config.constants';
@Component({
  selector: 'app-estimated-value',
  templateUrl: './estimated-value.component.html',
  styleUrls: ['./estimated-value.component.scss']
})
export class EstimatedValueComponent implements OnInit {

  @Input() listing: Listing;
  estimatedValue: number;
  loading = true;

  constructor(private homeEstimatorService: HomeEstimatorService, private userService: UserService) { }

  ngOnInit() {
    if (this.listing.province === BritishColumbiaStateShort && this.listing.isOffMarket && !this.userService.isGoogleBot()) {
      const homeEstimatorRequest: HomeEstimatorRequest = this.generateHomeEstimatorRequest(this.listing);

      this.homeEstimatorService.getSuggestions(homeEstimatorRequest).then((data: ObjectResponse<Property[]>) => {
        if (data.result.length > 0) {
          data.result[0].jurisdiction_Descp = data.result[0].jurisdiction_Descp.split(',')[0];
          return this.homeEstimatorService.getHomeEstimate(data.result[0]);
        } else {
          this.loading = false;
        }
      }).then((homeEstimate: ObjectResponse<HomeEstimatorResponse>) => {
        if (homeEstimate.result) {
          this.estimatedValue = homeEstimate.result.marketValue * 1.05;
        }
        this.loading = false;
      }).catch(() => this.loading = false);
    } else {
      this.loading = false;
    }
  }

  private generateHomeEstimatorRequest(listing: Listing): HomeEstimatorRequest {
    let unitNumber;
    let streetDirection: string;
    let streetName: string;
    const location  = listing.city;

    // check if unit number is provided in address and split unit and rest of address
    let address = listing.address.split('-');
    if (address.length > 1) {
      unitNumber = address[0].trim();
      address = address[1].trim().split(' ');
    } else {
      address = address[0].split(' ');
    }

    const streetNumber = address[0];
    // if last part is a street direction strip part out of the streetName and add to streetDirection
    const addressStreetOrDirection = address[address.length - 1];
    if (/^([NSEW]){1}$/g.test(addressStreetOrDirection)) {
      streetDirection = addressStreetOrDirection;
      streetName = address.slice(1, address.length - 1).join(' ');
    } else {
      streetName =  address.slice(1).join(' ');
    }

    return { unitNumber, streetNumber, streetName, location, streetDirection };
  }
}
